import { alpha, Box, Stack } from '@mui/material';
import React from 'react';

import { MobileBody, MobileTitle } from '../Typography';

const BOTTOM_RADIUS = 24;

export interface HeroHeaderProps {
  title: string;
  subtitle?: string;
  /** Chip opcional a la altura del título (ej. status). Se muestra en flex junto al title. */
  statusChip?: React.ReactNode;
  fadeColor?: string;
  minHeight?: number | string;
  children?: React.ReactNode;
  sx?: object;
}

const HeroHeader: React.FC<HeroHeaderProps> = ({
  title,
  subtitle,
  statusChip,
  fadeColor,
  minHeight = 50,
  children,
  sx,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        borderBottomLeftRadius: BOTTOM_RADIUS,
        borderBottomRightRadius: BOTTOM_RADIUS,
        overflow: 'hidden',
        background: (theme) => {
          const base = fadeColor ?? theme.palette.primary.main;
          return `linear-gradient(135deg, ${alpha(base, 0.12)} 0%, ${alpha(base, 0.05)} 50%, ${alpha(base, 0.01)} 100%)`;
        },
        ...sx,
      }}
    >
      {children != null && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& > *': { maxWidth: '100%', maxHeight: '100%' },
          }}
        >
          {children}
        </Box>
      )}
      <Box
        sx={{
          position: 'relative',
          px: 2,
          pb: 1.5,
          pt: 1,
        }}
      >
        <Stack spacing={0.25} alignItems="flex-end">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 1.5,
              minWidth: 0,
              width: '100%',
            }}
          >
            {statusChip != null && (
              <Box sx={{ flexShrink: 0 }}>{statusChip}</Box>
            )}
            <MobileTitle
              sx={{
                color: 'text.secondary',
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'right',
              }}
            >
              {title}
            </MobileTitle>
          </Box>
          {subtitle != null && subtitle !== '' && (
            <MobileBody
              component="span"
              sx={{
                color: 'text.secondary',
                fontWeight: 400,
                textAlign: 'right',
              }}
            >
              {subtitle}
            </MobileBody>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default HeroHeader;
